import errorHandler from "common/errorHandler";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { Endpoints } from "services/api";
import * as actions from "./actions";

const getTenant = (state) => state.userLogin.tenant;
const getUser = (state) => state.userLogin.user;

function* getPicklistDomainData(api, tenantId, dataDomainId, pageKey) {
    let params = {};
    if (pageKey) {
        params.pageKey = pageKey;
    }
    let result = yield call(
        [api, api.get],
        `${Endpoints.datasets}/api/v1/datadomains/${dataDomainId}/domaindata`,
        {}, // No need to pass in tenantId here as it is already included in the API base URL
        {
            params,
        },
    );
    return result.data;
}

export function* getPicklistDomainDataRequest(api, { dataDomainId, pageKey }) {
    try {
        let tenant = yield select(getTenant);
        let domainDataResult = yield call(getPicklistDomainData, api, tenant.tenantId, dataDomainId, pageKey);
        yield put(actions.getPicklistDomainDataSuccess(dataDomainId, domainDataResult, pageKey));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "picklist domain data");
        yield put(actions.getPicklistDomainDataFailure(dataDomainId, errorObject));
    }
}

export function* watchGetPicklistDomainDataRequest(api, { params }) {
    yield call(getPicklistDomainDataRequest, api, params);
}

export default function* ({ api }) {
    yield takeEvery(actions.GET_PICKLIST_DOMAIN_DATA_REQUEST, watchGetPicklistDomainDataRequest, api);
}
